import { convertEntities } from '@amzn/awscat-editor';
import { ContentMetadata } from '@amzn/awscat-pattern-library-service-model';
import React, { useContext } from 'react';
import { AppContext } from '../../contexts/AppContext';
import { Link } from '@amzn/awsui-components-core';

interface Props {
  contentId: string;
  metadata: ContentMetadata;
}

const ReviewerContentViewerLink: React.FunctionComponent<Props> = (props: Props) => {
  const { contentId, metadata } = props;
  const appContext = useContext(AppContext);
  return (
    <Link variant="secondary" href={`/content-viewer/reviewer/${contentId}`}>
      {convertEntities(metadata.contentName, appContext.entities)}
    </Link>
  );
};

export default ReviewerContentViewerLink;
